@if (item.customField22 == '1') {
  <div>
    <div style="margin-top: 50px;font-size: 20px;margin-bottom: 15px;" fxLayoutAlign="center center">
      Annual &#160;&#160;
      <mat-slide-toggle [(ngModel)]="isChecked" (change)="toggleChanged()" color="primary">Lifetime</mat-slide-toggle>
    </div>
    @for (data of pricedetail; track data) {
      <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        >
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
          <h3><b>{{data.title1}}</b></h3>
          <p> For growing businesses with a comprehensive set of features</p>
          @if (!isChecked) {
            <div>
              <h4><b>₹ {{data.s_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
              <h6>{{data.s_charge_year}}</h6>
            </div>
          }
          @if (isChecked) {
            <div>
              <h4><b>₹ {{data.s_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
              <h6>Annual maintenance charge : ₹ {{data.s_charge_life}}</h6>
            </div>
          }
          <button (click)="openInNewWindow(data.p_button)" mat-raised-button
          color="primary">{{data.s_button}}</button>
          <h5><b>{{data.s_subtitle}}</b></h5>
          @for (subdata of data.list_detail; track subdata) {
            <div style="margin-bottom: 10px;">
              @if (subdata.starters) {
                <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdata.starters}}</h6>
                </div>
              }
            </div>
          }
          <!-- <div>
          <div class="pricelist" >
            <mat-icon class="maticon3">check_circle</mat-icon>
            <h6 style="margin-bottom: 0px;">&#160;Partial Payment</h6>
          </div>
        </div> -->
      </div>
      <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="33" [style.background-color]="data.a_button"
        style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
        <h3><b>{{data.title2}}</b></h3>
        <p>Professional features to grow and manage your online store</p>
        @if (!isChecked) {
          <div>
            <h4><b>₹ {{data.p_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
            <h6 class="txtcolor">{{data.p_charge_year}}</h6>
          </div>
        }
        @if (isChecked) {
          <div>
            <h4><b>₹ {{data.p_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
            <h6 class="txtcolor"> Annual maintenance charge : ₹ {{data.p_charge_life}}</h6>
          </div>
        }
        <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
        <h5 class="txtcolor"><b>{{data.p_subtitle}}</b></h5>
        @for (subdatas of data.list_detail; track subdatas) {
          <div style="margin-bottom: 10px;">
            @if (subdatas.professions) {
              <div class="pricelist">
                <mat-icon class="maticon3">check_circle</mat-icon>
                <h6 style="margin-bottom: 0px;" class="txtcolor">&#160;&#160;{{subdatas.professions}}</h6>
              </div>
            }
          </div>
        }
      </div>
      <div contentAnim [aniName]="item.customField38" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
        <h3><b>{{data.title3}}</b></h3>
        <p>Ideal for established businesses with high-volume sales & Multiple Outlets</p>
        @if (!isChecked) {
          <div>
            <h4><b>₹ {{data.a_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
            <h6>{{data.a_charge_year}}</h6>
          </div>
        }
        @if (isChecked) {
          <div>
            <h4><b>₹ {{data.a_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
            <h6>Annual maintenance charge : ₹ {{data.a_charge_life}}</h6>
          </div>
        }
        <button (click)="openInNewWindow(data.p_button)" mat-raised-button
        color="primary">{{data.s_button}}</button>
        <h5><b>{{data.a_subtitle}}</b></h5>
        @for (subdataz of data.list_detail; track subdataz) {
          <div style="margin-bottom: 10px;">
            @if (subdataz.advanceds) {
              <div class="pricelist">
                <mat-icon class="maticon3">check_circle</mat-icon>
                <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdataz.advanceds}}</h6>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
}

<!----------- TYpe 2 ------------>


@if (item.customField22 == '2') {
  <div>
    @for (data of pricedetail; track data) {
      <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        >
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
          <h3><b>{{data.title1}}</b></h3>
          <div>
            <h4><b>₹ {{data.s_price_annualy}} </b></h4>
            <h6>{{data.s_charge_year}}</h6>
          </div>
          <button (click)="openInNewWindow(data.p_button)" mat-raised-button
          color="primary">{{data.s_button}}</button>
          <h5><b>{{data.s_subtitle}}</b></h5>
          @for (subdata of data.list_detail; track subdata) {
            <div style="margin-bottom: 10px;">
              @if (subdata.starters) {
                <div class="pricelist">
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <div>
                      <mat-icon class="maticon3">check_circle</mat-icon>
                    </div>
                    <div>
                      <h6 style="margin-bottom: 0px;font-size: 16px">&#160;{{subdata.starters}}</h6>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="33" [style.background-color]="data.a_button"
          style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
          <h3><b>{{data.title2}}</b></h3>
          <div>
            <h4><b>₹ {{data.p_price_annualy}}</b></h4>
            <h6 class="txtcolor">{{data.p_charge_year}}</h6>
          </div>
          <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
          <h5 class="txtcolor"><b>{{data.p_subtitle}}</b></h5>
          @for (subdatas of data.list_detail; track subdatas) {
            <div style="margin-bottom: 10px;">
              @if (subdatas.professions) {
                <div class="pricelist">
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <div>
                      <div class="circleiconz">
                        <mat-icon class="maticon_3">check_circle</mat-icon>
                      </div>
                    </div>
                    <div>
                      <h6 style="margin-bottom: 0px;padding-left: 10px;font-size: 16px" class="txtcolor">&#160;{{subdatas.professions}}</h6>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div contentAnim [aniName]="item.customField38" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
          <h3><b>{{data.title3}}</b></h3>
          <h4><b>₹ {{data.a_price_annualy}} </b></h4>
          <h6>{{data.a_charge_year}}</h6>
          <button (click)="openInNewWindow(data.p_button)" mat-raised-button
          color="primary">{{data.s_button}}</button>
          <h5><b>{{data.a_subtitle}}</b></h5>
          @for (subdataz of data.list_detail; track subdataz) {
            <div style="margin-bottom: 10px;">
              @if (subdataz.advanceds) {
                <div class="pricelist">
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <div>
                      <mat-icon class="maticon3">check_circle</mat-icon>
                    </div>
                    <div>
                      <h6 style="margin-bottom: 0px;font-size: 16px;">&#160;{{subdataz.advanceds}}</h6>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<!----------- Static design ------------>
@if (item.customField22 != '1' && item.customField22 != '2') {
 <div>
      <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        >
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px">
          <h3><b>STARTER</b></h3>
          <h5><b>5 USER</b></h5>
          <h4><b>₹ 10000</b> </h4>  
            <div style="margin-bottom: 10px;margin-top: 10px;">
                <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;No extra cost for adding up to 5 users</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Store up to 40000 Leads</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;No Cusomization</h6>
                </div>
            </div>
             <div class="cta-button">
                  <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
            </div>
         </div>

        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px;background-color: #66A6ED;color: #ffffff;" >
          <h3><b>PROFESSIONAL</b></h3>
          <h5><b>5 USER</b></h5>
          <h4><b>₹ 500 / Month</b> </h4>
          <p>Billed Annually on premise</p>
          <h4><b>₹ 250 / Month</b> </h4>
          <p>Billed Annually</p>

            <div style="margin-bottom: 10px;margin-top: 10px;">
                <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;1 user 800 /month billed halferly</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Store up to 50000 leads</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Cusomization With Additional Pricing</h6>
                </div>
            </div>
            <div style="margin-bottom: 20px;margin-top: 15px;" >
                <button (click)="scrollDown('seocrm')" mat-raised-button color="primary" style="background-color: white;color: black;">Book a Demo</button>            
            </div>
          </div>  

        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px">
          <h3><b>UNLIMITED</b></h3>
          <h5><b>UNLIMITED USER</b></h5>
          <h4><b>₹ 11999/ Month</b> </h4>
          <p>Billed Annually</p>

            <div style="margin-bottom: 10px;margin-top: 10px;">
                <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Store up to 100000 Leads</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Cusomization With Additional Pricing</h6>
                </div>
            </div>
            <div class="cta-button">            
                <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
            </div>
         </div>         
        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px;background-color: #66A6ED;color: #ffffff;">
          <h3><b>UNLIMITED MAX</b></h3>
          <h5><b>UNLIMITED USER</b></h5>
          <h4><b>₹ 70000/ Month</b> </h4>
          <p>Billed Annually</p>

            <div style="margin-bottom: 10px;margin-top: 10px;">
                <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Store up to 1100000 Leads</h6>
                </div>
                  <div class="pricelist">
                  <mat-icon class="maticon3">check_circle</mat-icon>
                  <h6 style="margin-bottom: 0px;">&#160;&#160;Basic Customization</h6>
                </div>
            </div>
              <div class="cta-button">            
                      <button (click)="scrollDown('seocrm')" mat-raised-button color="primary" style="background-color: white;color:black;">Book a Demo</button>            
              </div>
            </div>         
      </div>
</div>
}